import React, { FC } from 'react';
import ThemedErrorMessage from '../presentation/error/ThemedErrorMessage';
import SectionLoader from '../loaders/SectionLoader';
import Loader from '../presentation/Loader';

export interface ISectionStatesProps {
  error?: any;
  loading?: boolean;
}

interface ISectionStatesWrapperProps extends ISectionStatesProps {
  loaderType?: 'shimmer' | 'bar';
}

const SectionStatesWrapper: FC<ISectionStatesWrapperProps> = ({ error, loading, loaderType = 'shimmer', children }) => {
  if (error) {
    return <ThemedErrorMessage message={'spc.common.error.general'} error={error} />;
  }

  if (loading) {
    return loaderType === 'shimmer' ? <SectionLoader /> : <Loader />;
  }

  return <>{children}</>;
};

export default SectionStatesWrapper;
